// extracted by mini-css-extract-plugin
export default {"container":"_ZIi0C","sufix":"ccY6dJ","spinnerPlaceholder":"zkWDuD"};